import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { ZoomParticipant } from '../models/zoomparticipants.model';
import { ZoomMeeting } from '../models/zoommeeting.model';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ZoomParticipantService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/ZoomParticipant`;

  getMeetings(): Observable<ZoomMeeting[]> {
    return this.http.get<any[]>(`${this.baseUrl}/Meetings`).pipe(
      map((list) =>
        list.map((m) => ({
          id: m.meetingId,
          meetingId: m.meetingId,
          topic: m.topic,
        })),
      ),
    );
  }

  getAllParticipants(): Observable<ZoomParticipant[]> {
    return this.http.get<any[]>(`${this.baseUrl}/AllParticipants`).pipe(
      map((list) =>
        list.map((p) => ({
          id: p.id,
          name: p.name,
          email: p.email,
          joinTime: p.joinTime,
          leaveTime: p.leaveTime,
          duration: p.duration,
          meetingId: p.meetingId,
          activityId: p.activityId,
        })),
      ),
    );
  }

  exportMonthlyExcel(
    request: any,
    mode: 'kurs' | 'teilnehmer',
  ): Observable<Blob> {
    const endpoint =
      mode === 'kurs'
        ? `${this.baseUrl}/ExportMonthlyByCourse`
        : `${this.baseUrl}/ExportMonthlyByParticipants`;

    return this.http.post(endpoint, request, { responseType: 'blob' });
  }

  uploadExcel(formData: FormData) {
  return this.http.post<string[]>(
    `${environment.apiUrl}/FileUpload/UploadFile`,
    formData
  );
}

downloadFile(url: string): Observable<Blob> {
  return this.http.get(url, { responseType: 'blob' });
}
 uploadFiles(formData: FormData) {
    return this.http.post<string[]>(
      `${environment.apiUrl}/FileUpload/UploadFile`,
      formData
    );
  }

  // Liste der Dateien im Bucket abrufen
  getBucketFiles(bucket: string, prefix?: string) {
    let url = `${environment.apiUrl}/FileUpload/GetFiles/${bucket}`;
    if (prefix) {
      url += `?prefix=${prefix}`;
    }
    return this.http.get<{ name: string; url: string }[]>(url);
  }

  getMyUploadedFiles(bucket: string, prefix: string) {
  return this.http.get<{ name: string; url: string }[]>(
    `${environment.apiUrl}/FileUpload/GetFiles/${bucket}?prefix=${prefix}`
  );
}

getPresignedUrl(bucket: string, objectName: string) {
  return this.http.get<string>(
    `${environment.apiUrl}/FileUpload/GetSignedURL/${bucket}/${objectName}`
  );
}

downloadFileFromPresigned(bucket: string, objectName: string) {
  return this.getPresignedUrl(bucket, objectName).pipe(
    switchMap(url =>
      this.http.get(url, { responseType: 'blob' })
    )
  );
}

}